import axios from 'axios'
import { URLS } from '../../util/urls'
import tools from '../../util/tools'
import debugHelper from '../../util/debug'
import functions from '../../functions'


const state = {
  activeTabName: 'tabRecentFiles', // 当前激活页

  isMultiSelect: false, // 标识是否选择状态
  selectedFiles: [], // 选中的文件列表

  recentFileTotalCount: 0, // 总记录数
  downloadFileTotalCount: 0, // 总记录数

  recentFiles: [],  // 最近打开的文档
  downloadFiles: [], // 下载的文档

  recentFileFilter: '', // 文档过滤条件 
  downloadFileFilter: '', // 文档过滤条件 

  isDownloading: false, // 是否正在下载标记
  downloadingFileInfo: null, // 正在下载的文件信息（注意：文档页下载文件时需要赋值，流程详情页无需赋值）
}

const getters = {
  getActiveTabName: state => {
    return state.activeTabName
  },
  getIsMultiSelect: state => {
    return state.isMultiSelect
  },
  getSelectedFiles: state => {
    return state.selectedFiles
  },
  getRecentFileTotalCount: state => {
    return state.recentFileTotalCount
  },
  getDownloadFileTotalCount: state => {
    return state.downloadFileTotalCount
  },
  getRecentFiles: state => {
    return state.recentFiles
  },
  getDownloadFiles: state => {
    return state.downloadFiles
  },
  getRecentFileFilter: state => {
    return state.recentFileFilter
  },
  getDownloadFileFilter: state => {
    return state.downloadFileFilter
  },
  getIsDownloading: state => {
    return state.isDownloading
  },
}

const actions = {
  fetchRecentFilesTotalCount: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      // 查询总记录数
      functions.sqliteHelper
        .queryFilesDataTotalCount(0, {})
        .then((resultSet) => {
          commit('setRecentFileTotalCount', { value: resultSet.rows.item(0).totalCount })
          resolve()
        })
    })
  },
  fetchDownloadFilesTotalCount: ({ commit }, params) => {
    // 查询总记录数
    functions.sqliteHelper
      .queryFilesDataTotalCount(1, {})
      .then((resultSet) => {
        commit('setDownloadFilesTotalCount', { value: resultSet.rows.item(0).totalCount })
      })
  },

  // 从本地Sqllite数据库，读取最近文件信息（用于首页查询 或 不分页查询）
  fetchRecentFiles: ({ commit }, params) => {
    console.log('调试代码')
    // 组装搜索条件
    var filterInfo = {}
    if (state.recentFileFilter != '') {
      filterInfo = {
        fileName: state.recentFileFilter,
        tname: state.recentFileFilter,
      }
    } else {
      filterInfo = {}
    }
    // 查询
    functions.sqliteHelper
      .queryFilesData(0, 0, params.data.limit, filterInfo)
      .then((resultSet) => {
        commit('setRecentFiles', {
          value: resultSet,
        })
      })
  },
  // 从本地Sqllite数据库，读取最近文件信息（用于翻页追加查询）
  appendRecentFiles: ({ commit }, params) => {
    console.log('调试代码')
    // 组装搜索条件
    var filterInfo = {}
    if (state.recentFileFilter != '') {
      filterInfo = {
        fileName: state.recentFileFilter,
        tname: state.recentFileFilter,
      }
    } else {
      filterInfo = {}
    }
    // 查询
    functions.sqliteHelper
      .queryFilesData(0, params.data.skip, params.data.limit, filterInfo)
      .then((resultSet) => {
        commit('setAppendRecentFiles', {
          value: resultSet,
        })
      })
  },

  // 从本地Sqllite数据库，读取下载文件信息（用于首页查询 或 不分页查询）
  fetchDownloadFiles: ({ commit }, params) => {
    console.log('调试代码')
    // 组装搜索条件
    var filterInfo = {}
    if (state.downloadFileFilter != '') {
      filterInfo = {
        flowFileName: state.downloadFileFilter,
        tname: state.downloadFileFilter,
      }
    } else {
      filterInfo = {}
    }
    // 查询
    functions.sqliteHelper
      .queryFilesData(1, 0, params.data.limit, filterInfo)
      .then((resultSet) => {
        commit('setDownloadFiles', {
          value: resultSet,
        })
      })
  },
  // 从本地Sqllite数据库，读取下载文件信息（用于翻页追加查询）
  appendDownloadFiles: ({ commit }, params) => {
    console.log('调试代码')
    // 组装搜索条件
    var filterInfo = {}
    if (state.downloadFileFilter != '') {
      filterInfo = {
        flowFileName: state.downloadFileFilter,
        tname: state.downloadFileFilter,
      }
    } else {
      filterInfo = {}
    }
    // 查询
    functions.sqliteHelper
      .queryFilesData(1, params.data.skip, params.data.limit, filterInfo)
      .then((resultSet) => {
        commit('setAppendDownloadFiles', {
          value: resultSet,
        })
      })
  },
}

function readFileInfo(resultItem) {
  var fileInfo = {
    isFlowFile: resultItem.isFlowFile, // 标识是否流程文件 1 是，0 不是
    fileWholeName: resultItem.fileWholeName, // 路径+文件名
    fileName: resultItem.fileName, // 文件名
    flowID: resultItem.flowID, // 流程ID
    flowName: resultItem.flowName, // 流程名称
    flowFileURL: resultItem.flowFileURL, // 流程文件下载URL
    flowFileName: resultItem.flowFileName, // 流程文件名
    encrypted: resultItem.encrypted, // 文件是否加密
    key: resultItem.key, // 打开加密文件所用的密钥
    userOID: resultItem.userOID, // 用户OID
    orgID: resultItem.orgID, // 组织OID
    clID: resultItem.clID, // 文件密级
    fileID: resultItem.fileID, // 文件ID,
    tid: resultItem.tid,
    tname: resultItem.tname,
    downloadPer: resultItem.downloadPer,
  }
  // alert('functions.sqliteHelper.getData' + JSON.stringify(fileInfo))
  return fileInfo
}

const mutations = {
  setActiveTabName: (state, payload) => {
    state.activeTabName = payload.value
  },
  setIsMultiSelect: (state, payload) => {
    state.isMultiSelect = payload.value
  },
  setSelectedFiles: (state, payload) => {
    state.selectedFiles = payload.value
  },
  setRecentFileTotalCount: (state, payload) => {
    state.recentFileTotalCount = payload.value
  },
  setDownloadFilesTotalCount: (state, payload) => {
    state.downloadFileTotalCount = payload.value
  },

  setRecentFiles: (state, payload) => {
    state.recentFiles.splice(0, state.recentFiles.length)
    for (var x = 0; x < payload.value.rows.length; x++) {
      var fileInfo = readFileInfo(payload.value.rows.item(x))
      state.recentFiles.push(fileInfo)
    }
  },
  setAppendRecentFiles: (state, payload) => {
    for (var x = 0; x < payload.value.rows.length; x++) {
      var fileInfo = readFileInfo(payload.value.rows.item(x))
      state.recentFiles.push(fileInfo)
    }
  },
  setDownloadFiles: (state, payload) => {
    state.downloadFiles.splice(0, state.downloadFiles.length)
    for (var x = 0; x < payload.value.rows.length; x++) {
      var fileInfo = readFileInfo(payload.value.rows.item(x))
      state.downloadFiles.push(fileInfo)
    }
  },
  setAppendDownloadFiles: (state, payload) => {
    for (var x = 0; x < payload.value.rows.length; x++) {
      var fileInfo = readFileInfo(payload.value.rows.item(x))
      state.downloadFiles.push(fileInfo)
    }
  },
  setRecentFilesFilter: (state, payload) => {
    state.recentFileFilter = payload.value
  },
  setDownloadFilesFilter: (state, payload) => {
    state.downloadFileFilter = payload.value
  },
  setIsDownloading: (state, payload) => {
    console.log('调试代码')
    // 置下载状态，以便控制界面文件下载进度条的显示（转圈圈）
    state.isDownloading = payload.value

    // 记忆正在下载的文件信息（注意：文档页下载文件时需要赋值，流程详情页无需赋值）
    if (payload.downloadingFileInfo) {
      state.downloadingFileInfo = payload.downloadingFileInfo
      state.downloadingFileInfo.downloadPer = 0
    }
    // 置正在下载的文件信息的下载状态,以便控制文档页文件的进度条（水平进度条）
    if (state.downloadingFileInfo) {
      state.downloadingFileInfo.isDownloading = payload.value
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
